import { Observable } from 'rxjs'
import { HeliosMessage, HeliosMessageType } from './models/messaging.model'
import { HeliosEventFilterCriteria } from './models/websocket-filter.model'

export enum EventType {
  CONNECTED = 'connected',
  MESSAGE = 'message',
}

export abstract class MessagingService {
  abstract connect(url: string, extras?: Record<string, string>): void
  abstract disconnect(): void
  abstract send<T>(message: T): void
  abstract setFilters(key: string, filters: HeliosEventFilterCriteria[]): void
  abstract deleteFilters(key: string): void
  abstract on<K, T extends HeliosMessage<K>>(
    type: EventType,
    filters?: HeliosMessageType | HeliosMessageType[],
  ): Observable<T>
}

export abstract class SessionMessagingService extends MessagingService {}

export abstract class GlobalMessagingService extends MessagingService {}
